import { render, staticRenderFns } from "./new-column-modal.vue?vue&type=template&id=460d66a6&scoped=true&"
import script from "./new-column-modal.vue?vue&type=script&lang=js&"
export * from "./new-column-modal.vue?vue&type=script&lang=js&"
import style0 from "./new-column-modal.vue?vue&type=style&index=0&id=460d66a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d66a6",
  null
  
)

export default component.exports